"use client";

import PreLoader from "@/components/Common/PreLoader";
import ScrollToTop from "@/components/Common/ScrollToTop";
import CacheRefreshButton from "@/components/Common/CacheRefreshButton";
import CookieConsent from "@/components/Common/CookieConsent";
import NextTopLoader from "nextjs-toploader";
import { Toaster } from "react-hot-toast";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useStoreStatus } from "@/components/StoreStatusProvider/StoreStatusProvider";
import { Ecommerce } from "@/lib/nexus-app";
import StoreClosed from "@/components/StoreClosed/StoreClosed";
import StoreClosedBanner from "@/components/StoreClosed/StoreClosedBanner";
import StoreClosedDialog from "@/components/StoreClosed/StoreClosedDialog";
import StorePausedDialog from "@/components/StoreClosed/StorePausedDialog";

export function SiteLayoutClient({
  host,
  children,
  ecommerce,
}: {
  host: string;
  children: React.ReactNode;
  ecommerce: Ecommerce;
}) {
  const pathname = usePathname();
  const { isOpen, isPaused } = useStoreStatus();

  useEffect(() => {
    if (ecommerce.name) {
      document.title = ecommerce.name;
    }
  }, [ecommerce.name]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <PreLoader />
      <NextTopLoader
        color="#3C50E0"
        crawlSpeed={300}
        showSpinner={false}
        shadow="none"
      />
      {!isOpen &&
        (isPaused ? (
          <StorePausedDialog ecommerce={ecommerce} />
        ) : (
          <StoreClosedDialog ecommerce={ecommerce} />
        ))}
      <div className="flex flex-col min-h-screen">
        <Header host={host} />
        <Toaster position="top-center" reverseOrder={false} containerStyle={{ zIndex: 999999 }} />
        <main className="flex-1">{children}</main>
        <ScrollToTop />
        <CacheRefreshButton />
        <CookieConsent />
        <Footer />
      </div>
    </>
  );
}
